<!-- Notifications toggle -->
<button
    mat-icon-button
    (click)="openPanel()"
    #cartOrigin>
            <mat-icon
                [matBadge]="cart?cart.products.length:0" matBadgeSize="small" matBadgeColor="warn" [matBadgeHidden]="!cart || cart?.products.length == 0"
                [svgIcon]="'heroicons_outline:shopping-cart'"></mat-icon>
</button>


<!-- Notifications panel -->
<ng-template #cartPanel>

    <div class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-90 sm:rounded-2xl overflow-hidden shadow-2xl">
        <!-- Header -->
        <div class="flex shrink-0 items-center py-4 pr-4 pl-6 bg-primary text-on-primary">
            <div class="sm:hidden -ml-1 mr-3">
                <button
                    mat-icon-button
                    (click)="closePanel()">
                    <mat-icon
                        class="icon-size-5 text-current"
                        [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
                </button>
            </div>
            <div class="text-lg font-medium leading-10">{{ 'Produse' | transloco }} {{cart ? "("+cart.products.length+")":""}}</div>
            <div class="ml-auto">
                <button
                    class="dark:text-white"
                    mat-icon-button
                    [matTooltip]="'Feature management' | transloco"
                    [disabled]="!cart || cart.products.length === 0"
                    [routerLink]="['/admin/feature-mgmt']">
                    <mat-icon
                        class="icon-size-5 text-current"
                        [svgIcon]="'heroicons_outline:adjustments-horizontal'"></mat-icon>
                </button>
            </div>
        </div>
        <!-- simulate shadow -->
        <div class="z-40 h-10 min-h-10 max-h-10 w-full bg-gradient-to-b from-black to-transparent opacity-25" style="pointer-events: none;"></div>
        <!-- Content -->
        <div class="-mt-10 relative flex flex-col flex-auto sm:h-180 sm:max-h-120 divide-y overflow-y-auto bg-card max-w-240">
            <!-- Products -->
            <ng-container *ngIf="cart?.orderStatus && cart?.orderStatus != OrderStatus.PENDING_PAYMENT">
                <ng-container *ngFor="let cartItem of cart?.products; trackBy: trackByFn; last as last">
                <div
                    class="flex group hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5">
                    <ng-container>
                        <div class="flex flex-auto py-5 pl-6">
                            <ng-container *ngTemplateOutlet="cartContent"></ng-container>
                        </div>
                    </ng-container>
                </div>
                <div *ngIf="!last" class="border-b border-gray-200 dark:border-gray-700"></div>

                <ng-template #cartContent>
                    <div class="flex flex-col gap-2 w-full">

                            <div class="flex flex-row gap-2 w-full items-center justify-between">
                                <!-- Icon -->
                                <ng-container *ngIf="cartItem.icon">
                                    <div
                                        class="flex shrink-0 items-center justify-center mr-2">
                                        <mat-icon
                                            class="icon-size-8"
                                            [svgIcon]="cartItem.icon">
                                        </mat-icon>
                                    </div>
                                </ng-container>
                                <div class="flex flex-col gap-2 w-full">
                                    <ng-container *ngIf="cartItem.name">
                                        <div
                                            class="font-semibold line-clamp-1"
                                            [innerHTML]="cartItem.name"></div>
                                    </ng-container>
                                </div>
                                <!-- Actions -->
                                <div class="relative flex flex-col my-2 mr-6 ml-2">
                                    <!-- Remove -->
                                    <button
                                        class="w-6 h-6 min-h-6 sm:opacity-0 sm:group-hover:opacity-100"
                                        mat-icon-button
                                        (click)="delete(cartItem)"
                                        [matTooltip]="'Remove' | transloco">
                                        <mat-icon
                                            class="icon-size-4"
                                            [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                                    </button>
                                </div>
                        </div>

                        <ng-container *ngIf="cartItem.priceDetails">
                            <div class="flex flex-col text-sm leading-none text-secondary mb-4"
                                 [innerHTML]="formatDescription(cartItem.priceDetails)"></div>

                        </ng-container>


                        <div class="flex flex-row gap-2 items-start justify-between w-full pr-4">
                            <!-- Multiplicator -->
                            <div class="flex flex-row space-x-2">
                                <ng-container *ngIf="cartItem.productCategory == ProductCategory.RESOURCE">
                                    <mat-form-field appearance="outline" floatLabel="always" class="w-full">
                                        <mat-label>{{ 'Number' | transloco | titlecase }}</mat-label>
                                        <input  matInput type="number" [value]="cartItem.count"
                                                min="1" (change)="updateAmount(cartItem, $event.target.value)">
                                    </mat-form-field>
                                </ng-container>

                                <ng-container *ngIf="cartItem.productCategory == ProductCategory.MODULE && ('MODULE_'+cartItem.internalPrefixCode) == ModuleAndResourceIDs.ABONAMENT">
                                    <mat-form-field appearance="outline" floatLabel="always" class="w-full">
                                        <mat-label>{{ 'Valabilitate' | titlecase }}</mat-label>
                                        <mat-select (selectionChange)="updateAmount(cartItem, $event.value)" [value]="cartItem.count.toString()">
                                            <mat-option value="1">1 luna</mat-option>
                                                <mat-option value="12">1 an</mat-option>
                                            </mat-select>
                                    </mat-form-field>
                                </ng-container>
                            </div>
                            <!-- Pret -->
                            <div class="flex flex-col ml-2">
                                <ng-container *ngIf="cartItem.price">
                                    <div
                                        class="font-semibold line-clamp-1 text-xl"> Pret
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="cartItem.price">
                                    <div class="text-lg leading-none text-secondary line-clamp-2">
                                        {{ cartItem.price | number: "1.2" }} <b>RON</b>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                </ng-template>
            </ng-container>
            </ng-container>

            <!-- Payment processing -->
            <ng-container *ngIf="cartBlocked()">
                <div class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
                    <div class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100 dark:bg-primary-600 animate-ping">
                        <mat-icon
                            class="text-primary-700 dark:text-primary-50"
                            [svgIcon]="'heroicons_outline:credit-card'"></mat-icon>
                    </div>
                    <div class="mt-5 text-2xl font-semibold tracking-tight">{{ 'Payment in process...' | transloco }}</div>
                    <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">{{'Please wait' | transloco}}</div>
                    <div class="w-full flex flex-row justify-center items-center gap-4 mt-2">
                        <smm-butt
                            [settings]="{
                                text:'Resume payment' | transloco,
                                color:'primary',
                                smallMatType:'icon',
                                auto:false}"
                            (click)="goToCheckout()"></smm-butt>

                        <smm-butt
                            [settings]="{
                                text:'Cancel' | transloco,
                                color:'warn',
                                smallMatType:'icon',
                                auto:false}"
                            (click)="cancelOrder()"></smm-butt>
                    </div>
                </div>
            </ng-container>

            <!-- No products -->
            <ng-container *ngIf="!cart || !cart.products.length">
                <div class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
                    <div class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100 dark:bg-primary-600">
                        <mat-icon
                            class="text-primary-700 dark:text-primary-50"
                            [svgIcon]="'heroicons_outline:shopping-cart'"></mat-icon>
                    </div>
                    <div class="mt-5 text-2xl font-semibold tracking-tight">{{ 'Nu sunt produse in cos' | transloco }}</div>
                    <div class="w-full max-w-60 mt-1 text-lg text-center text-primary cursor-pointer" (click)="closePanel()" [routerLink]="'admin/feature-mgmt'">{{'Adauga produse' | transloco}}</div>
                </div>
            </ng-container>

        </div>

        <!-- simulate shadow -->
        <div *ngIf="cart.products.length > 0"
            class="-mt-10 h-10 min-h-10 max-h-10 w-full bg-gradient-to-t from-black to-transparent opacity-25" style="pointer-events: none;"></div>
        <div *ngIf="cart.products.length > 0"
            class="flex flex-col items-end font-bold justify-start py-4 px-4 bg-card border border-collapse border-l-0 border-r-0 border-b-0 border-t-4 border-primary">

            <!-- Billing -->
            <form *ngIf="!cartBlocked()" [formGroup]="billingInfo" class="w-full">
                <div class="grid grid-cols-1 w-full min-w-0">
                    <mat-form-field *ngIf="(companies?.length + persons?.length) > 0" class="w-full">
                        <mat-label>{{ "Billing" | transloco }}</mat-label>
                        <mat-select
                            id="info"
                            [placeholder]="'Select' | transloco"
                            [formControlName]="'info'"
                        >
                            <ng-container *ngFor="let person of persons">
                                <mat-option [value]="getBillingInfo( person.id, EnumBillingType.PERSONAL)" >
                                        <mat-icon
                                            [svgIcon]="'heroicons_solid:user'"
                                            class="icon-size-5"
                                            matPrefix></mat-icon>
                                        <div class="flex flex-col">
                                            <div class="text-lg font-bold">{{person.fullName}}</div>
                                            <div class="text-sm text-hint"> {{person.address}}</div>
                                        </div>
                                </mat-option>
                            </ng-container>
                            <ng-container *ngFor="let company of companies">
                                <mat-option [value]="getBillingInfo( company.id, EnumBillingType.COMPANY)">
                                    <mat-icon
                                        [svgIcon]="'heroicons_solid:building-office'"
                                        class="icon-size-5"
                                        matPrefix></mat-icon>
                                    <div class="text-lg font-bold">{{company.companyName}}</div>
                                    <div class="text-sm text-hint"> CUI: {{company.cui}}</div>
                                </mat-option>
                            </ng-container>
                        </mat-select>
                        <mat-icon
                            [svgIcon]="'heroicons_solid:credit-card'"
                            class="icon-size-5"
                            matPrefix></mat-icon>
                        <mat-error *ngIf="billingInfo.get('info').hasError('required')">
                            {{ "This information is required" | transloco }}
                        </mat-error>
                    </mat-form-field>

                    <ng-container *ngIf="(companies?.length + persons?.length) == 0">
                        <fuse-alert
                            (click)="closePanel()"
                            class="cursor-pointer"
                            [routerLink]="['/admin/billing-info']"
                            [appearance]="'outline'"
                            [showIcon]="true"
                            [type]="'warning'">
                            {{ "Billing info missing. Click to add." | transloco}}
                        </fuse-alert>
                    </ng-container>
                </div>
            </form>

            <div class="text-2xl">
                Total: {{ cart?.totalAmount | number: "1.2" }} RON
            </div>
        </div>

        <div *ngIf="cart.products.length > 0"
            class="flex flex-col items-center justify-center pb-4 px-4 bg-card">
            <button
                [hidden]="billingInfo.invalid || billingInfo.pristine"
                mat-stroked-button
                class="w-full"
                color="primary"
                (click)="goToCheckout()">
                {{ 'Finalizare comanda' | transloco }}
            </button>
        </div>
    </div>

</ng-template>
